
export const LABELMAP: Record<string, string> = {
    PROMO: 'Promoters',
    SHR_ASOF: 'Shareholding As of Date',
    SHR_DIL_ASOF: 'Diluted Shareholding As of Date',
    DII: 'Domestic Institutions',
    FII: 'Foreign Institutions',
    GOVT: 'Government',
    RETAIL: 'Retail Investors',
    EMP: 'Employee Holdings',
    PUBLIC: 'Public Holding',
    PUB_DOMESTIC: 'Domestic Public',
    PUB_FOREIGN: 'Foreign Public',
    CORP: 'Corporate Holdings',
    SMALLHANDS: 'Small Investors',
    SMARTM: 'Smart Money',
    MIDRETAIL: 'Mid-tier Retail Investors',
    FII_FDI: 'Foreign Direct Investment by FIIs',
    FII_FPI1: 'Foreign Portfolio Investors (Type 1)',
    FII_FPI2: 'Foreign Portfolio Investors (Type 2)',
    DII_MF: 'Mutual Funds under DII',
    DII_INS: 'Insurance under DII',
    DII_BANKS: 'Banks under DII'
};
